import React from 'react'

const Support = () => {
  return (
    <section className="mx-auto max-w-6xl px-3 py-4 sm:px-4 sm:py-6 md:py-10">
      <div className="rounded-xl border border-orange-100/70 bg-white/90 p-4 shadow-modern backdrop-blur-sm sm:rounded-2xl sm:p-8 md:p-12">
        <header className="max-w-4xl text-left">
          <p className="text-[10px] font-bold uppercase tracking-[0.28em] text-brand sm:text-sm sm:tracking-[0.35em] md:text-base">
            Support It&apos;s Yummtime
          </p>
          <h1 className="mt-2.5 text-2xl font-bold leading-snug tracking-tight text-warm-charcoal sm:mt-5 sm:text-4xl sm:leading-tight md:text-5xl lg:text-6xl">
            Need help with an issue on our website? We&apos;re here to assist.
          </h1>
          <p className="mt-3 max-w-4xl text-sm leading-relaxed text-warm-gray-600 sm:mt-8 sm:text-xl">
            If you&apos;re experiencing any trouble while using It&apos;s Yummtime, our support team is
            ready to help. Reach out for technical issues, account questions, or anything that is
            affecting your experience.
          </p>
        </header>

        <div className="mt-5 grid gap-3 sm:mt-10 sm:gap-5 md:grid-cols-3">
          <article className="rounded-xl bg-orange-50/65 p-4 shadow-sm sm:rounded-2xl sm:p-7">
            <h2 className="text-lg font-semibold tracking-tight text-warm-charcoal sm:text-3xl">
              Website Issues
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-warm-gray-700 sm:mt-4 sm:text-xl">
              Contact us if pages are not loading correctly, links are broken, or features are not
              working as expected.
            </p>
          </article>

          <article className="rounded-xl bg-orange-50/65 p-4 shadow-sm sm:rounded-2xl sm:p-7">
            <h2 className="text-lg font-semibold tracking-tight text-warm-charcoal sm:text-3xl">
              Account Help
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-warm-gray-700 sm:mt-4 sm:text-xl">
              Get assistance with sign-in issues, subscription concerns, or saved-recipe access so
              you can get back to cooking quickly.
            </p>
          </article>

          <article className="rounded-xl bg-orange-50/65 p-4 shadow-sm sm:rounded-2xl sm:p-7">
            <h2 className="text-lg font-semibold tracking-tight text-warm-charcoal sm:text-3xl">
              General Assistance
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-warm-gray-700 sm:mt-4 sm:text-xl">
              Share your questions, report problems you had before, or request guidance for any
              part of the website experience.
            </p>
          </article>
        </div>

        <div className="mt-5 flex justify-center sm:mt-10 sm:justify-end">
          <a
            href="mailto:itsyummtime@sweetestinteractive.com"
            className="nav-get-started-lines inline-flex h-10 items-center rounded-lg bg-gradient-to-r from-orange-500 to-orange-600 px-5 text-sm font-semibold text-white shadow-modern transition-all duration-300 hover:-translate-y-0.5 hover:from-orange-600 hover:to-orange-700 hover:shadow-glow sm:h-14 sm:rounded-xl sm:px-8 sm:text-2xl"
          >
            <span className="relative z-10">Email Support</span>
          </a>
        </div>
      </div>
    </section>
  )
}

export default Support
